import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { colors, fontWeights, gutterSizes } from '../base/theme';

export const ExpandableListWrapper = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
`;

export const ExpandableListContainer = styled.div<{ isMobile: boolean }>`
    display: grid;
    grid-template-columns: ${({ isMobile }) => (isMobile ? '1fr' : '1fr 1fr')};
    gap: 16px;
    margin-bottom: ${gutterSizes.medium10};
`;

export const ExpandableListItem = styled.div<{ isEllipsis: boolean; itemsPerRow: number }>`
    width: 100%;
    display: flex;
    align-items: center;

    ${({ isEllipsis }) => isEllipsis && css`
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `}

    .icon {
        padding-right: ${gutterSizes.base};
        flex-shrink: 0;
    }

    .text-content {
        ${({ isEllipsis }) => isEllipsis && css`
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `}
    }
`;

export const ExpandableListButton = styled.button`
    background: none;
    border: none;
    color: ${colors.blue};
    cursor: pointer;
    padding: 0;
    font-weight: ${fontWeights.normal};
    font-family: inherit;
    line-height: 2;
    
    &:hover {
        text-decoration: underline;
    }
`;
